var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-3d"},[_c('div',{class:['card ', _vm.value  ? 'card-front' : 'card-front-click']},[_vm._t("front")],2),_c('div',{class:['card',  _vm.value  ? 'card-back' : 'card-back-click']},[_vm._t("back")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }